const localInput = (date: Date) => {
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const toDatetimeLocal = (iso: string | null | undefined) =>
  iso ? localInput(new Date(iso)) : "";

// datetime-local liefert "YYYY-MM-DDTHH:mm" ohne Zonenangabe; interpretiert
// wird die lokale Zeit des Redakteurs, daraus entsteht ein ISO-String mit
// Offset, damit der Server ihn nicht in seiner eigenen Zeitzone parsen kann.
export const fromDatetimeLocal = (value: string | null | undefined) => {
  if (!value) return null;
  const match = value.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::\d{2})?$/,
  );
  if (!match) return null;
  const [, year, month, day, hour, minute] = match;
  const minutes = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
  ).getTimezoneOffset();
  const sign = minutes < 0 ? "+" : "-";
  const offset = `${sign}${String(Math.floor(Math.abs(minutes) / 60)).padStart(2, "0")}:${String(Math.abs(minutes) % 60).padStart(2, "0")}`;
  return `${year}-${month}-${day}T${hour}:${minute}:00${offset}`;
};
